import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { IAppState } from 'types/app.types';
import { IBlogsState } from 'types/blogs.types';
import { IServicesState } from 'types/services.types';
import { IUserState } from 'types/user.types';
import { IUsersState } from 'types/users.types';

export interface IRootState {
  app: IAppState;
  blogs: IBlogsState;
  services: IServicesState;
  user: IUserState;
  users: IUsersState;
}

const useTypedSelector: TypedUseSelectorHook<IRootState> = useSelector;

export default useTypedSelector;
